import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {AssetDisplayState, initialAssetDisplayState} from 'common/src/modules/Assets/Assets.types';
import {RemoteAiContentProject} from '../../aiContentProject.types';
import {RemoteAiContentItem} from '../../aiContentItem.types';

export interface AiContentProjectState {
  project: RemoteAiContentProject | null;
  isLoading: boolean;
  error: string | null;
  loadedProjectId: number | null;
  items: RemoteAiContentItem[];
  itemsLoading: boolean;
  itemsError: string | null;
  loadedItemsProjectId: number | null;
  template: CreativeTemplate | null;
  templateLoading: boolean;
  templateError: string | null;
  projectAssets: AssetDisplayState;
}

export const AI_CONTENT_PROJECT_INITIAL_STATE: AiContentProjectState = {
  project: null,
  isLoading: false,
  error: null,
  loadedProjectId: null,
  items: [],
  itemsLoading: false,
  itemsError: null,
  loadedItemsProjectId: null,
  template: null,
  templateLoading: false,
  templateError: null,
  projectAssets: initialAssetDisplayState,
};

